import type { ReactElement, ReactNode } from "react"

import styles from "./ExpandableSection.module.scss"

type ExpandableSectionProps = {
  headerContent: ReactNode
  children: ReactNode
  open?: boolean
}

export function ExpandableSection(props: Readonly<ExpandableSectionProps>): ReactElement {
  const { headerContent, children, open = false } = props

  return (
    <details open={open} className={styles.details}>
      <summary>{headerContent}</summary>
      {children}
    </details>
  )
}
